import React from 'react';
import styled from 'styled-components';

const MinedBlocksRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export default MinedBlocksRow;
